
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import ReactWOW from 'react-wow';

import {
  TabContent,
  TabPane,
  Button,
} from 'reactstrap';
import { connect } from 'react-redux';

import CampaignCard from './CampaignCard';

class FeaturedVouchers extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    getVouchers: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      enabled: false,
      activeTab: 2,
    };
  }

  componentDidMount() {
    const { user } = this.props;
  }

  render() {
    const { vouchersList, featured } = this.props;
    const {
    } = this.state;

    return (
            <div className="row">
              <div className="col-12">
                    <div className="row" style={{ minHeight: 480 }}>
                      <>
                        {(() => {
                          const rows = [];
                          for (let i = 0; i < 4; i++) {
                            let hasFeatured = false;
                            let hasVouchers = false;

                            if (featured && featured.length) {
                              hasFeatured = true;
                            }

                            if (vouchersList && Object.keys(vouchersList).length) {
                              hasVouchers = true;
                            }

                            let voucher = null;
                            let voucherId = null;

                            if (hasFeatured && featured[i]) {
                              voucher = featured[i];
                              voucherId = featured[i].key;
                            } else {
                              voucher = undefined;
                            }

                            rows.push(
                                <div className="col-lg-3 col-md-4 col-12 single-item-grid-wrapper">
                                  <CampaignCard
                                    type={voucherId}
                                    key={voucherId}
                                    vouchersList={vouchersList}
                                    display={!(hasFeatured)}
                                    voucher={voucher}
                                    voucherId={voucherId}
                                  />
                                </div>
                            );
                          }
                          return rows;
                        })()}
                      </>
                    </div>
              </div>
            </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  featured: state.customer.featured || null,
});

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeaturedVouchers));